import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

export default function bootstrap(node, config) {
  ReactDOM.render(
    <App {...config} />,
    node,
  );
}